import React from 'react';
import PropTypes from 'prop-types';

import {Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Translate} from 'views/module';

const AdminClockInEvent = (props) => {
  const {closeModel, event, onAdminClockIn} = props;
  const [isSaving, setIsSaving] = React.useState(false);

  const caregiverName = event.caregiverData?.caregiverDetail?.caregiverName;

  const onSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    await onAdminClockIn(
        event.eventRn,
        () => {
          closeModel(true);
        },
    );
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression='schedule.eventDetail.AdminClockInDialog.Title'/>
      </DialogTitle>
      <DialogContent>
        <Typography>
          <Translate expression='schedule.eventDetail.AdminClockInDialog.Description' substitute={{caregiverName}}/>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Cancel'/>
        </Button>
        <Button onClick={onSave} disabled={isSaving}>
          <Translate expression='generic.Confirm'/>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AdminClockInEvent.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  onAdminClockIn: PropTypes.func.isRequired,
};

export default AdminClockInEvent;
